import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, unref as _unref } from "vue";
var _hoisted_1 = {
  class: "data-quest"
};
var _hoisted_2 = {
  key: 0,
  class: "data-quest_left"
};
var _hoisted_3 = {
  key: 1,
  class: "data-quest_left"
};
var _hoisted_4 = {
  class: "quest_tips"
};
var _hoisted_5 = {
  key: 0
};
var _hoisted_6 = {
  class: "quest_text"
};
var _hoisted_7 = {
  class: "quest_time"
};
var _hoisted_8 = {
  class: "time_timing"
};
var _hoisted_9 = {
  class: "time_warn"
};
var _hoisted_10 = {
  key: 0,
  class: "each-content"
};
import dayjs from 'dayjs';
import { validateNull } from '@/util/validate';
export default {
  __name: 'TodoItem',
  props: {
    item: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  emits: ['change', 'check'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emit = __emit;
    // 判断是否有选择框
    var isShowCheck = function isShowCheck(type, isContain) {
      if (type === 2 && isContain) {
        return true;
      } else if (type === 1 || type === 4) {
        return true;
      } else {
        return false;
      }
    };
    // 计算时间
    var timeShow = function timeShow(val) {
      var startTime = val.startTime,
        endTime = val.endTime,
        backlogType = val.backlogType;
      if (backlogType === 3) {
        return "".concat(dayjs(Number(startTime)).format('HH:mm'), "-").concat(dayjs(Number(endTime)).format('HH:mm'));
      }
      if (val.type === 1) {
        return val.range;
      } else if (val.type === 2) {
        return "".concat(dayjs(Number(startTime)).format('MM-DD'), "~").concat(dayjs(Number(endTime)).format('MM-DD'));
      } else {
        return "".concat(dayjs(Number(endTime)).format('MM'), "\u6708");
      }
    };
    // 提醒时间渲染
    var homeReminder = function homeReminder(val) {
      if (validateNull(val) || Number(val.remindTime) === 0) return '';
      if (val.type > 1) {
        var time = dayjs(Number(val.remindTime)).format('MM-DD HH:mm');
        return "".concat(time, "\u63D0\u9192");
      } else {
        var offset = Number(val.startTime) - Number(val.remindTime);
        var start = dayjs(offset).format('m');
        return val.backlogType === 4 ? "\u7ED3\u675F\u524D30\u5206\u949F\u63D0\u9192" : "\u5F00\u59CB\u524D".concat(start, "\u5206\u949F\u63D0\u9192");
      }
    };
    return function (_ctx, _cache) {
      var _props$item;
      var _component_svg_icon = _resolveComponent("svg-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [isShowCheck(__props.item.backlogType, __props.item.participant) ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", {
        class: _normalizeClass({
          'default-border': !__props.item.isOverdue && !__props.item.isChecked,
          'overdue-border': __props.item.isOverdue,
          'checked-background': __props.item.isChecked
        }),
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return emit('check', __props.item);
        })
      }, null, 2)])) : (_openBlock(), _createElementBlock("div", _hoisted_3, [!__props.item.participant && __props.item.backlogType === 2 ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 0,
        class: "un-book-icon",
        name: "mark"
      })) : _createCommentVNode("", true), __props.item.backlogType === 3 ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 1,
        class: "un-book-icon",
        name: "book-line"
      })) : _createCommentVNode("", true)])), _createElementVNode("div", {
        class: "data-quest_right",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return emit('change', __props.item);
        })
      }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
        class: "quest_day",
        style: _normalizeStyle({
          background: __props.item.color
        })
      }, [__props.item.colorText ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(__props.item.colorText), 1)) : (_openBlock(), _createBlock(_component_svg_icon, {
        key: 1,
        class: "book-icon",
        name: "book-line-white"
      }))], 4), _createElementVNode("div", _hoisted_6, _toDisplayString(__props.item.content), 1)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(__props.item.backlogType === 4 ? _unref(dayjs)(Number(__props.item.startTime)).format('HH:mm') : timeShow(__props.item)), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(homeReminder(__props.item, 'bottom')), 1), __props.item.backlogType === 3 ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString((_props$item = __props.item) === null || _props$item === void 0 || (_props$item = _props$item.scheduleUserDetailsVo) === null || _props$item === void 0 ? void 0 : _props$item.place), 1)) : _createCommentVNode("", true)])])]);
    };
  }
};